import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../state/AppStore'
import { updateService } from '../UpdateService'
import { websocketConnection } from './Websockets'
import { WebsocketConnectionStatus } from './WebsocketConnectionStatus'
import { friendsService } from '../FriendsService'

export const usePersistentWebsocketConnection = () => {
	const activeUserId = useSelector((root: RootState) => root.activeUser.user?.id)
	const websocketConnectionStatus = useSelector((root: RootState) => root.websocketConnection.status)

	useEffect(() => {
		if (activeUserId) {
			websocketConnection.setup(activeUserId)
			websocketConnection.connect()

			updateService.setup()
			friendsService.setup()
		} else {
			websocketConnection.disconnect()
		}

		return () => {
			updateService.cleanup()
			friendsService.cleanup()
			websocketConnection.disconnect()
		}
	}, [activeUserId])

	useEffect(() => {
		if (websocketConnectionStatus === WebsocketConnectionStatus.Connected) {
			updateService.refreshAll()
		}
	}, [websocketConnectionStatus])
}
